import { memo, useRef, useState, useEffect } from 'react'
import { Link, Routes, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
  FaTachometerAlt, 
  FaDollarSign, 
  FaQuestionCircle, 
  FaSignOutAlt, 
  FaBars, 
  FaCog, 
  FaHistory, 
  FaUsers, 
  FaBullhorn, 
  FaFileAlt, 
  FaWhatsapp, 
  FaShoppingBag, 
  FaBell, 
  FaChevronDown,
  FaTicketAlt
} from 'react-icons/fa';
import { TbMessageChatbotFilled } from 'react-icons/tb';
import Swal from 'sweetalert2';
import { removeToken } from '../whatsapp/function/token';

import Maindashboard from '../whatsapp/small_component/dashboard/maindashboard.jsx';
import Createtemplate from '../whatsapp/small_component/template/createtemplate.jsx';
import Documentation from '../whatsapp/small_component/documentation.jsx';
import Myaccount from '../whatsapp/small_component/users/myaccount.jsx';
import Managetemplate from '../whatsapp/small_component/template/managetemplate.jsx';
import Subscription from '../whatsapp/small_component/biling/subscription.jsx';
import Paymenthistory from '../whatsapp/small_component/biling/paymenthistory.jsx';
import Changepassword from '../whatsapp/small_component/users/changepassword.jsx';
import BroadcastCampaign from '../whatsapp/small_component/campaigns/broadcastcampaign.jsx';
import BroadcastType from '../whatsapp/small_component/campaigns/broadcastType.jsx';
import ManageCampaigns from '../whatsapp/small_component/campaigns/managecampaigns.jsx';
import Whatsappchat from '../whatsapp/small_component/whatsappchat/whatsappchat.jsx';
import ContactsTable from '../whatsapp/small_component/whatsappchat/ContactsTable.jsx';
import Agents from '../whatsapp/small_component/agents/Agents.jsx';
import ApplicationProtectedRouting from '../routing/ApplicationProtectedRouting.jsx';
import ChatBot from '../whatsapp/small_component/chatBot/ChatBot.jsx';
import ManageChatbots from '../whatsapp/small_component/chatBot/ManageChatbots.jsx';
import ChatbotConfiguration from '../whatsapp/small_component/chatBot/ChatbotConfiguration.jsx';
import WalletHistory from '../whatsapp/small_component/wallet/WalletHistory.jsx';
import ApiModel from '../whatsapp/small_component/apiModel/ApiModel.jsx';
import UserRoles from '../whatsapp/small_component/users/UserRoles.jsx';
import CreateEditRole from '../whatsapp/small_component/users/CreateEditRole.jsx';
import FacebookPages from '../whatsapp/small_component/dashboard/FacebookPages.jsx';
import PaymentConfiguration from '../whatsapp/small_component/sitesetting/PaymentConfiguration.jsx';
import WebhookConfiguration from '../whatsapp/small_component/sitesetting/WebhookConfiguration.jsx';
import LinkDevice from '../whatsapp/small_component/settings/LinkDevice.jsx';
import SendingMessages from '../whatsapp/small_component/messages/SendingMessages.jsx';
import Marketplace from '../whatsapp/small_component/marketplace/Marketplace.jsx';
import GooglesheetManage from '../whatsapp/small_component/marketplace/googlesheet/GooglesheetManage.jsx';
import Googlesheet from '../whatsapp/small_component/marketplace/googlesheet/Googlesheet.jsx';
import AutoResponder from '../whatsapp/small_component/chatBot/AutoResponder.jsx';
import MessageLink from '../whatsapp/small_component/settings/MessageLink.jsx';

import TicketList from './support/TicketList.jsx';
import RaiseTicket from './support/RaiseTicket.jsx';
import TicketDetail from './support/TicketDetail.jsx';

import '../CommerceManager/Commercemanagerdashboard.css';
import '../whatsapp/assets/css/style.css';
import '../whatsapp/assets/css/typicons.css';
import '../whatsapp/assets/css/select2.min.css';
import WebsiteLogo from '../assets/images/logo.png';
import { ToastContainer } from 'react-toastify';

const Dashboard = memo(function Whatsappdashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(typeof window !== 'undefined' ? window.innerWidth > 992 : true);
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const location = useLocation();

  const userServices = useSelector((state) => state.serviceStore?.value);
  const userinformation = useSelector((state) => state.serviceStore?.value?.business_name) ?? 'Mitra Infotech';
  const userRole = useSelector((state) => state.Permissions?.value?.isAgent);

  // Notification States
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.filter(n => !n.read).length;

  const handleMenuClick = (menuName) => {
    if (activeMenu !== menuName) {
      setActiveMenu(menuName);
    } else {
      setActiveMenu("");
    }
  };

  const handleSubMenuClick = (subMenuName) => {
    setActiveSubMenu(subMenuName);
    if (typeof window !== 'undefined' && window.innerWidth <= 992) {
      setIsSidebarOpen(false);
    }
  };

  const handleToggleNotifications = () => {
    if (!showNotificationModal) {
      setShowNotificationModal(true);
      setNotificationLoading(true);
      setTimeout(() => {
        setNotificationLoading(false);
      }, 800);
    } else {
      setShowNotificationModal(false);
    }
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const markAsRead = (id) => {
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
  };

  const getActiveMenu = () => {
    const path = location.pathname;
    if (path.includes("/whatsapp/dashboard")) return "Dashboard";
    if (path.includes("/whatsapp/broadcast-campaign") || path.includes("/whatsapp/manage-campaigns") || path.includes("/whatsapp/campaign/")) return "Broadcast Campaign";
    if (path.includes("/whatsapp/agents") || path.includes("/whatsapp/contacts")) return "Users";
    if (path.includes("/whatsapp/chat-bot") || path.includes("/whatsapp/manage-chatbots") || path.includes("/whatsapp/chatbot-configuration") || path.includes("/whatsapp/auto_responder")) return "Chat Bot";
    if (path.includes("/whatsapp/create-template") || path.includes("/whatsapp/manage-template") || path.includes("/whatsapp/edit-template")) return "Manage Templates";
    if (path.includes("/whatsapp/whatsapp-chats") || path.includes("/whatsapp/live-chat")) return "Whatsapp Chats";
    if (path.includes("/whatsapp/marketplace")) return "Marketplace";
    if (path.includes("/whatsapp/message-history")) return "Message History";
    if (path.includes("/whatsapp/my-account") || path.includes("/whatsapp/link-device") || path.includes("/whatsapp/message-link") || path.includes("/whatsapp/change-password") || path.includes("/whatsapp/user-roles") || path.includes("/whatsapp/payment-configuration") || path.includes("/whatsapp/webhook-configuration")) return "Settings";
    if (path.includes("/whatsapp/subscription") || path.includes("/whatsapp/payment-history") || path.includes("/whatsapp/wallet-history")) return "Billing";
    if (path.includes("/whatsapp/tickets")) return "Tickets";
    return "";
  };

  const getActiveSubMenu = () => {
    const path = location.pathname;
    if (path.includes("/whatsapp/broadcast-campaign")) return "Create";
    if (path.includes("/whatsapp/manage-campaigns")) return "Manage Campaigns";
    if (path.includes("/whatsapp/agents")) return "Agents";
    if (path.includes("/whatsapp/contacts")) return "Contacts";
    if (path.includes("/whatsapp/chatbot-configuration")) return "Chatbot Configuration";
    if (path.includes("/whatsapp/auto_responder")) return "Auto Responder";
    if (path.includes("/whatsapp/create-template")) return "Create Template";
    if (path.includes("/whatsapp/manage-template")) return "Manage Templates";
    if (path.includes("/whatsapp/my-account")) return "Profile";
    if (path.includes("/whatsapp/link-device")) return "Link Device";
    if (path.includes("/whatsapp/message-link")) return "Message Link";
    if (path.includes("/whatsapp/change-password")) return "Update Password";
    if (path.includes("/whatsapp/user-roles")) return "User Roles";
    if (path.includes("/whatsapp/payment-configuration")) return "Payment Configuration";
    if (path.includes("/whatsapp/webhook-configuration")) return "Webhook Configuration";
    if (path.includes("/whatsapp/subscription")) return "Subscription";
    if (path.includes("/whatsapp/payment-history")) return "Payment History";
    if (path.includes("/whatsapp/wallet-history")) return "Wallet History";
    if (path.includes("/whatsapp/tickets/create")) return "Raise Ticket";
    if (path.includes("/whatsapp/tickets")) return "My Tickets";
    return "";
  };

  useEffect(() => {
    setActiveMenu(getActiveMenu());
    setActiveSubMenu(getActiveSubMenu());
    if (typeof window !== 'undefined' && window.innerWidth <= 992) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  return (
    <div className="commerce_dashboard-wrapper" style={{ fontFamily: '"Outfit", "Inter", sans-serif' }}>
      
      {/* Overlay for Mobile */}
      {isSidebarOpen && (
        <div className="commerce_overlay d-lg-none" onClick={() => setIsSidebarOpen(false)}></div>
      )}

      {/* Sidebar */}
      <div className={`commerce_sidebar d-flex flex-column py-3 ${isSidebarOpen ? 'commerce_active-mobile' : 'commerce_closed'}`}>
        <div className="commerce_sidebar-logo-container">
            <img src={WebsiteLogo} alt="logo" />
        </div>
        <div className="bg-white" style={{height: "5px"}}></div>
        <div className="flex-grow-1 overflow-auto pt-3">
          
          {/* Dashboard Link */}
          <Link to="/client-area/whatsapp/dashboard" className={`commerce_nav-link ${activeMenu === "Dashboard" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Dashboard")}>
            <FaTachometerAlt className="me-3" size={16} />
            <span>Dashboard</span>
          </Link>

          {/* Broadcast Campaign */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Broadcast Campaign" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Broadcast Campaign")}>
              <FaBullhorn className="me-3" size={16} />
              <span>Broadcast Campaign</span>
            </Link>
            {activeMenu === "Broadcast Campaign" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/broadcast-campaign" className={`commerce_sub-menu-item ${activeSubMenu === "Create" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Create")}>
                  Create
                </Link>
                <Link to="/client-area/whatsapp/manage-campaigns" className={`commerce_sub-menu-item ${activeSubMenu === "Manage Campaigns" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Manage Campaigns")}>
                  Manage Campaigns
                </Link>
              </div>
            )}
          </div>

          {/* Users */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Users" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Users")}>
              <FaUsers className="me-3" size={16} />
              <span>Users</span>
            </Link>
            {activeMenu === "Users" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/agents" className={`commerce_sub-menu-item ${activeSubMenu === "Agents" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Agents")}>
                  Agents
                </Link>
                <Link to="/client-area/whatsapp/contacts" className={`commerce_sub-menu-item ${activeSubMenu === "Contacts" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Contacts")}>
                  Contacts
                </Link>
              </div>
            )}
          </div>

          {/* Chat Bot */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Chat Bot" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Chat Bot")}>
              <TbMessageChatbotFilled className="me-3" size={16} />
              <span>Chat Bot</span>
            </Link>
            {activeMenu === "Chat Bot" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/chatbot-configuration" className={`commerce_sub-menu-item ${activeSubMenu === "Chatbot Configuration" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Chatbot Configuration")}>
                  Chatbot Configuration
                </Link>
                <Link to="/client-area/whatsapp/auto_responder" className={`commerce_sub-menu-item ${activeSubMenu === "Auto Responder" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Auto Responder")}>
                  Auto Responder
                </Link>
              </div>
            )}
          </div>

          {/* Manage Templates */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Manage Templates" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Manage Templates")}>
              <FaFileAlt className="me-3" size={16} />
              <span>Manage Templates</span>
            </Link>
            {activeMenu === "Manage Templates" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/create-template" className={`commerce_sub-menu-item ${activeSubMenu === "Create Template" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Create Template")}>
                  Create Template
                </Link>
                <Link to="/client-area/whatsapp/manage-template" className={`commerce_sub-menu-item ${activeSubMenu === "Manage Templates" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Manage Templates")}>
                  Manage Templates
                </Link>
              </div>
            )}
          </div>

          {/* Whatsapp Chats */}
          {userServices?.whatsapp_chat === 1 && (
            <Link to="/client-area/whatsapp/whatsapp-chats" className={`commerce_nav-link ${activeMenu === "Whatsapp Chats" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Whatsapp Chats")}>
              <FaWhatsapp className="me-3" size={16} />
              <span>Whatsapp Chats</span>
            </Link>
          )}

          {/* Marketplace */}
          <Link to="/client-area/whatsapp/marketplace" className={`commerce_nav-link ${activeMenu === "Marketplace" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Marketplace")}>
            <FaShoppingBag className="me-3" size={16} />
            <span>Marketplace</span>
          </Link>

          {/* Message History */}
          <Link to="/client-area/whatsapp/message-history" className={`commerce_nav-link ${activeMenu === "Message History" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Message History")}>
            <FaHistory className="me-3" size={16} />
            <span>Message History</span>
          </Link>

          {/* Settings */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Settings" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Settings")}>
              <FaCog className="me-3" size={16} />
              <span>Settings</span>
            </Link>
            {activeMenu === "Settings" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/my-account" className={`commerce_sub-menu-item ${activeSubMenu === "Profile" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Profile")}>
                  Profile
                </Link>
                <Link to="/client-area/whatsapp/link-device" className={`commerce_sub-menu-item ${activeSubMenu === "Link Device" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Link Device")}>
                  Link Device
                </Link>
                <Link to="/client-area/whatsapp/message-link" className={`commerce_sub-menu-item ${activeSubMenu === "Message Link" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Message Link")}>
                  Message Link
                </Link>
                <Link to="/client-area/whatsapp/change-password" className={`commerce_sub-menu-item ${activeSubMenu === "Update Password" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Update Password")}>
                  Update Password
                </Link>
                <Link to="/client-area/whatsapp/user-roles" className={`commerce_sub-menu-item ${activeSubMenu === "User Roles" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("User Roles")}>
                  User Roles
                </Link>
                <Link to="/client-area/whatsapp/payment-configuration" className={`commerce_sub-menu-item ${activeSubMenu === "Payment Configuration" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Payment Configuration")}>
                  Payment Configuration
                </Link>
                <Link to="/client-area/whatsapp/webhook-configuration" className={`commerce_sub-menu-item ${activeSubMenu === "Webhook Configuration" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Webhook Configuration")}>
                  Webhook Configuration
                </Link>
              </div>
            )}
          </div>

          {/* Billing */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Billing" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Billing")}>
              <FaDollarSign className="me-3" size={16} />
              <span>Billing</span>
            </Link>
            {activeMenu === "Billing" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/subscription" className={`commerce_sub-menu-item ${activeSubMenu === "Subscription" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Subscription")}>
                  Subscription
                </Link>
                <Link to="/client-area/whatsapp/payment-history" className={`commerce_sub-menu-item ${activeSubMenu === "Payment History" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Payment History")}>
                  Payment History
                </Link>
                <Link to="/client-area/whatsapp/wallet-history" className={`commerce_sub-menu-item ${activeSubMenu === "Wallet History" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Wallet History")}>
                  Wallet History
                </Link>
              </div>
            )}
          </div>

          {/* Support Tickets */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Tickets" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Tickets")}>
              <FaTicketAlt className="me-3" size={16} />
              <span>Support Tickets</span>
            </Link>
            {activeMenu === "Tickets" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/whatsapp/tickets" className={`commerce_sub-menu-item ${activeSubMenu === "My Tickets" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("My Tickets")}>
                  My Tickets
                </Link>
                <Link to="/client-area/whatsapp/tickets/create" className={`commerce_sub-menu-item ${activeSubMenu === "Raise Ticket" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Raise Ticket")}>
                  Raise Ticket
                </Link>
              </div>
            )}
          </div>
          {/* Logout */}
          <Link className="commerce_nav-link" onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to Logout this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes Logout",
            }).then((result) => {
              if (result.isConfirmed) {
                removeToken();
                Swal.fire({
                  title: "Logout!",
                  text: "Logout Successful",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1000,
                });
                setTimeout(() => {
                  window.history.pushState({}, "", "/");
                  window.dispatchEvent(new Event("popstate"));
                }, 1000);
              }
            });
          }}>
            <FaSignOutAlt className="me-3" size={16} />
            <span>Logout</span>
          </Link>

        </div>
      </div>

      {/* Main Content Area */}
      <div className={`commerce_main-content ${isSidebarOpen ? '' : 'commerce_expanded'}`}>
        
        {/* Top Navbar */}
        <div className="bg-white px-3 py-2 d-flex align-items-center justify-content-between shadow-sm sticky-top" style={{height: "70px"}}>
          <div className="d-flex align-items-center">
            <button 
              className="btn btn-link text-secondary p-0 me-3" 
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              style={{ fontSize: "20px" }}
            >
              <FaBars />
            </button>
            <span className="fw-bold d-md-none">Campaigning Tool</span>
          </div>

          {/* Right Header Navigation - Profile & Notifications */}
          <div className="d-flex align-items-center gap-3">
            
            {/* Notification Bell */}
            <div
              className="position-relative me-2"
              style={{ cursor: 'pointer' }}
              onClick={handleToggleNotifications}
              title="Notifications"
            >
              <FaBell style={{ fontSize: '18px', color: '#64748b' }} />
              {unreadCount > 0 && (
                <span
                  className="position-absolute p-1 bg-danger border border-light rounded-circle"
                  style={{ width: '9px', height: '9px', top: '-2px', right: '-2px' }}
                ></span>
              )}
            </div>

            {/* User Profile */}
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-circle text-white fw-bold d-flex align-items-center justify-content-center"
                style={{
                  width: '38px',
                  height: '38px',
                  backgroundColor: '#075E54',
                  fontSize: '15px'
                }}
              >
                {userinformation.charAt(0).toUpperCase()}
              </div>
              <div className="d-none d-md-flex flex-column text-start" style={{ lineHeight: '1.2' }}>
                <span className="fw-bold text-dark" style={{ fontSize: '13.5px' }}>{userinformation}</span>
                <span className="text-muted small" style={{ fontSize: '11.5px' }}>{userRole ? "Agent" : "Admin"}</span>
              </div>
            </div>

          </div>
        </div>

        {/* Notifications Modal Popup */}
        {showNotificationModal && (
          <div
            className="position-absolute shadow-lg rounded-4 bg-white border"
            style={{
              top: '65px',
              right: '16px',
              width: 'calc(100vw - 32px)',
              maxWidth: '380px',
              zIndex: 9999,
              overflow: 'hidden'
            }}
          >
            <div
              className="p-3 text-white d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#075E54' }}
            >
              <div className="d-flex align-items-center gap-2">
                <FaBell />
                <h6 className="m-0 fw-bold">Notifications</h6>
                {unreadCount > 0 && (
                  <span className="badge bg-danger rounded-pill ms-1" style={{ fontSize: '10px' }}>{unreadCount} New</span>
                )}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white btn-sm"
                onClick={() => setShowNotificationModal(false)}
              ></button>
            </div>

            <div className="p-2" style={{ maxHeight: '420px', overflowY: 'auto' }}>
              {notificationLoading ? (
                <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                  <div
                    className="spinner-border text-success mb-2"
                    role="status"
                    style={{ width: '1.8rem', height: '1.8rem', color: '#075E54' }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="small fw-medium text-secondary" style={{ fontSize: '12.5px' }}>
                    Loading notifications...
                  </span>
                </div>
              ) : notifications.length === 0 ? (
                <div className="text-center py-4 text-muted small">No notifications available</div>
              ) : (
                notifications.map((n) => (
                  <div
                    key={n.id}
                    className={`p-3 mb-2 rounded-3 border transition-all cursor-pointer ${n.read ? 'bg-light text-muted' : 'bg-white border-success shadow-sm'
                      }`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => markAsRead(n.id)}
                  >
                    <div className="d-flex align-items-center justify-content-between mb-1 gap-2">
                      <div className="d-flex align-items-center gap-2 overflow-hidden">
                        <span className="badge bg-success bg-opacity-10 text-success fw-bold flex-shrink-0" style={{ fontSize: '10px', color: '#075E54' }}>
                          {n.sender}
                        </span>
                        <span className={`fw-bold small text-truncate ${n.read ? 'text-dark' : 'text-success'}`}>
                          {n.title}
                        </span>
                      </div>
                      <span className="text-muted flex-shrink-0" style={{ fontSize: '10px' }}>{n.time}</span>
                    </div>
                    <p className="mb-0 small text-secondary" style={{ fontSize: '12px', lineHeight: '1.4' }}>
                      {n.message}
                    </p>
                  </div>
                ))
              )}
            </div>

            <div className="p-2 bg-light border-top d-flex justify-content-between align-items-center">
              <button
                className="btn btn-link btn-sm text-decoration-none text-success fw-semibold p-1"
                style={{ fontSize: '12px', color: '#075E54' }}
                onClick={markAllAsRead}
                disabled={unreadCount === 0}
              >
                Mark all as read
              </button>
              <button
                className="btn btn-outline-secondary btn-sm rounded-pill px-3 py-1"
                style={{ fontSize: '11px' }}
                onClick={() => setShowNotificationModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* Content Body */}
        <div className="px-2 py-2">
          <ToastContainer position="top-right" autoClose={3000} />
          <Routes>
              <Route path='/dashboard' element={<ApplicationProtectedRouting element={<Maindashboard />} />} />
              <Route path='/create-template' element={<ApplicationProtectedRouting element={<Createtemplate />} />}/>
              <Route path='/edit-template/:templateId' element={<ApplicationProtectedRouting element={<Createtemplate />} />}/>
              <Route path='/manage-template' element={<ApplicationProtectedRouting element={<Managetemplate />} />}/>
              <Route path='/manage-template/:userid' element={<ApplicationProtectedRouting element={<Managetemplate />} />}/>
              <Route path='/my-account' element={<ApplicationProtectedRouting element={<Myaccount />} />}/>
              <Route path='/link-device' element={<ApplicationProtectedRouting element={<LinkDevice />} />}/>
              <Route path='/message-link' element={<ApplicationProtectedRouting element={<MessageLink />} />}/>
              <Route path='/documentation' element={<ApplicationProtectedRouting element={<Documentation />} />}/>
              <Route path='/subscription' element={<ApplicationProtectedRouting element={<Subscription />} />}/>
              <Route path='/payment-history' element={<ApplicationProtectedRouting element={<Paymenthistory product="whatsapp"/>} />}/>
              <Route path='/change-password' element={<ApplicationProtectedRouting element={<Changepassword />} />}/>
              <Route path='/user-roles' element={<ApplicationProtectedRouting element={<UserRoles />} />}/>
              <Route path='/user-roles/create' element={<ApplicationProtectedRouting element={<CreateEditRole />} />}/>
              <Route path='/user-roles/edit/:roleId' element={<ApplicationProtectedRouting element={<CreateEditRole />} />}/>
              <Route path='/broadcast-campaign' element={<ApplicationProtectedRouting element={<BroadcastCampaign />} />}/>
              <Route path='/manage-campaigns' element={<ApplicationProtectedRouting element={<ManageCampaigns />} />}/>
              <Route path='/campaign/:type' element={<ApplicationProtectedRouting element={<BroadcastType />} />}/>
              <Route path='/message-history' element={<ApplicationProtectedRouting element={<SendingMessages/>} />}/>
              <Route path='/whatsapp-chats' element={<ApplicationProtectedRouting element={<Whatsappchat />} />}/>
              <Route path='/live-chat' element={<ApplicationProtectedRouting element={<Whatsappchat />} />}/>
              <Route path='contacts' element={<ContactsTable/>}/>
              <Route path='agents' element={<ApplicationProtectedRouting element={<Agents />} />}/>
              <Route path='chat-bot' element={<ApplicationProtectedRouting element={<ChatBot />} />}/>
              <Route path='manage-chatbots' element={<ApplicationProtectedRouting element={<ManageChatbots />} />}/>
              <Route path='chatbot-configuration' element={<ApplicationProtectedRouting element={<ChatbotConfiguration />} />}/>
              <Route path='api-model' element={<ApplicationProtectedRouting element={<ApiModel />} />}/>
              <Route path='wallet-history' element={<ApplicationProtectedRouting element={<WalletHistory />} />} />
              <Route path='facebook-pages' element={<ApplicationProtectedRouting element={<FacebookPages />} />}/>
              <Route path='payment-configuration' element={<ApplicationProtectedRouting element={<PaymentConfiguration />} />}/>
              <Route path='webhook-configuration' element={<ApplicationProtectedRouting element={<WebhookConfiguration />} />}/>
              <Route path='/marketplace' element={<ApplicationProtectedRouting element={<Marketplace />} />}/>
              <Route path='/marketplace/googlesheet/create' element={<ApplicationProtectedRouting element={<Googlesheet />} />}/>
              <Route path='/marketplace/googlesheet/manage' element={<ApplicationProtectedRouting element={<GooglesheetManage />} />}/>
              <Route path='/marketplace/googlesheet/manage/:id' element={<ApplicationProtectedRouting element={<Googlesheet />} />}/>
              <Route path='/auto_responder' element={<ApplicationProtectedRouting element={<AutoResponder />} />}/>
              <Route path='/tickets' element={<ApplicationProtectedRouting element={<TicketList />} />}/>
              <Route path='/tickets/create' element={<ApplicationProtectedRouting element={<RaiseTicket />} />}/>
              <Route path='/tickets/detail/:id' element={<ApplicationProtectedRouting element={<TicketDetail />} />}/>
          </Routes>
        </div>

      </div>

    </div>
  );
});

export default Dashboard;
